export class currentdialogue {

    id:number;

    index:number;

    people:number;

    length:number;

    section:number;

    content:any;

    constructor() { }

    //是否最后一句
    IsLast(){
        return this.index==this.length;
    }

    Next(){
        this.index++;
    }

    GoFirst(){
        this.index = 0;
    }

    UnreadCount(dialogue){
        //for(var )
        let count = 0;
        for(var i=0;i<dialogue.length;i++)
            count += dialogue[i].unread;
        return count;
    }
}


// WEBPACK FOOTER //
// ./src/app/case-practice-hotel/currentdialogue.ts